<template>
    <div class="talkWithGuide-Consent">
        <div class="pageTitle">Consent to call</div>
        <p class="pageSubtitle">We <img class="heartIcon"
                 src="/img/heart-blue.png"
                 alt="Heart"> respecting privacy</p>
        <p class="p12"
           ref="consentText">
            By clicking the “Let’s Talk” you consent to truesecurity, using automated dialing technology, to contact you at the phone number you provided below regarding home security and other offers of goods and services even if the phone number is listed on any Do-Not-call list including True Securitie's Internal Do-Not-Call list. Also, by clicking the “Let’s Talk” you are not required to sign an agreement (directly or indirectly) and it is not a condition of purchasing any property, goods or services.
        </p>
        <p class="consentPhone"
           v-if="hasPhone">{{ lead.phone }}</p>
        <p class="consentBusinessHours">
            <span v-if="isBusinessHours">
                A guide will call you within 30 minutes
            </span>
            <span v-if="!isBusinessHours">
                A guide will call you during business hours (8am - 9pm CST)
            </span>
        </p>
        <label for="consent"
               :class="{'noMarginBottom': !hasButton}">
            <input type="checkbox"
                   id="consent"
                   v-model="consentToCall"> I agree
        </label>
        <button v-if="hasButton"
                type="button"
                :disabled="!consentToCall"
                class="button full"
                @click="consent">
            {{ buttonText }}
        </button>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex';
export default {
    props: {
        changeSection: Function,
        hasButton: {
            default: true
        },
        hasPhone: {
            default: true
        }
    },
    data: () => ({
        consentToCall: false,
        buttonText: "Let's talk"
    }),
    computed: {
        ...mapState([
            'lead',
            'isBusinessHours'
        ])
    },
    methods: {
        consent() {
            this.buttonText = 'loading...'
            let data = {
                name: this.lead.name,
                phone: this.lead.phone,
                consentText: this.$refs.consentText.textContent
            }
            axios.post('/ajax/ticket/talk-with-guide-request', data)
                .then(res => {
                    this.changeSection('Confirmation')
                    axios.post(`/api/talkWithGuideRequest/${res.data.leadId}/${res.data.consentId}`)
                    mixpanel.track('requestedTalkwithGuide', {
                        P_Guide_path: window.location.pathname
                    })

                    const eventName = 'TWG_submit'
                    const eventParameters = {}
                    // Do tracking
                    fbq('trackCustom', eventName, eventParameters)
                    gtag('event', eventName, eventParameters)
                    gtag('event', 'conversion', { 'send_to': 'AW-879819493/DSwNCPiCgoMBEOX1w6MD'});
                })
                .catch(e => {
                    alert('Whoops! Something went wrong. Please try again later.')
                })
        }
    },
    mounted() {
        this.$watch('consentToCall', (val) => {
            this.$store.state.consentToCall = val
        })
    }
}

</script>
